import { useContext } from "react";

import { ContextEp } from "./ep.context";

export const useContextEp = () => useContext(ContextEp);
